export const fixDealersStyles = () => {
    const widgetEl = document.getElementById('jlr-booking-widget');
    if(window.location.host === 'www.landrover.ru') {
        const problemParentEl = findAncestor(widgetEl, 'headerBox');
        if(problemParentEl) {
            problemParentEl.style.paddingLeft = 0;
            problemParentEl.style.paddingRight = 0;
            problemParentEl.style.width = '100%';
            problemParentEl.style.maxWidth = '1440px';
        }
    }
    if(window.location.host === 'www.jaguar.ru') {
        const problemParentEl = findAncestor(widgetEl, 'section');
        if(problemParentEl) {
            problemParentEl.style.minWidth = '1024px';
        }
    }
};

const findAncestor = (el, parentClass) => {
    while ((el = el.parentElement) && !el.classList.contains(parentClass));
    return el;
};



// WEBPACK FOOTER //
// ./src/fixDealersStyles.js